import * as types from "../../../redux/actions/ActionTypes";
import { getCurrentUserDetailsApi } from "../../apis/profile/getCurrentUserDetailsApi";
import { isPremiumPlan, isPremiumPlusPlan } from "../../../utils/planUtils";

export const getCurrentUserDetailsActionStart = () => ({
    type: types.CURRENT_USER_GET_START,
});

export const getCurrentUserDetailsActionSuccess = (data) => ({
    type: types.CURRENT_USER_GET_SUCCESS,
    payload: data,
});

export const getCurrentUserDetailsActionError = (error) => ({
    type: types.CURRENT_USER_GET_ERROR,
    payload: error,
});


let isFetchingUserDetails = false;
let fetchUserDetailsTimestamp = 0;

export const getCurrentUserDetailsActionInitiate = (auth = false, data, force = false) => {
    return async function (dispatch, getState) {
        // Prevent duplicate in-flight requests with a 10s timeout guard.
        // Both Sidebar instances, StrictMode double-invoke, and concurrent callers
        // all hit this guard — only the first one proceeds (or if stuck for >10s).
        if (!force && isFetchingUserDetails && Date.now() - fetchUserDetailsTimestamp < 10000) {
            return;
        }

        isFetchingUserDetails = true;
        fetchUserDetailsTimestamp = Date.now();

        dispatch(getCurrentUserDetailsActionStart());

        try {
            const res = await getCurrentUserDetailsApi(data);
            isFetchingUserDetails = false;

            if (res.data) {
                const userData = res.data;
                const userType = userData?.account_type || "user";
                const isVerified = userData?.status || "draft";
                const onboardingCompleted = userData?.onboarding_completed;

                // Helper to extract step number from "step1", "step2" or just use number
                const rawStep = userData?.current_step || "1";
                const currentStep = typeof rawStep === 'string'
                    ? (parseInt(rawStep.replace(/[^0-9]/g, ''), 10) || 1)
                    : (rawStep || 1);

                // Update storage for consistent routing
                const plan = userData?.subscription_plan;
                const planType = plan?.type || null;
                const isPremiumPlus = isPremiumPlusPlan(plan);
                const isPremium = isPremiumPlan(plan) && !isPremiumPlus;
                const isBasic = !!plan && !isPremium && !isPremiumPlus;

                localStorage.setItem("userType", userType);
                localStorage.setItem("planType", planType); // Correct key
                localStorage.setItem("is_subscribed_basic_plan", isBasic ? "true" : "false");
                localStorage.setItem("is_subscribed_premium_plan", isPremium ? "true" : "false");
                localStorage.setItem("is_subscribed_premium_plus_plan", isPremiumPlus ? "true" : "false");
                localStorage.setItem("isVerified", isVerified);
                localStorage.setItem("onboardingCompleted", onboardingCompleted === true ? "true" : "false");
                localStorage.setItem("currentStep", currentStep);
                localStorage.setItem("isNewBusinessUser", userData?.is_new_business_user === true ? "true" : "false");
                // upgrade_request_status is an object; store just the status string for fast-paint.
                if (userData?.upgrade_request_status !== undefined) {
                    const urStatus = userData.upgrade_request_status?.status || "";
                    localStorage.setItem("upgradeRequestStatus", urStatus);
                }
                // Only upgrade phoneVerified to "true" — never downgrade a verified session
                // via a background fetch. The authoritative "true" is set during OTP verification.
                if (userData?.phone_verified) {
                    localStorage.setItem("phoneVerified", "true");
                }

                if (auth) {
                    // Manual window.location.href is removed to allow seamless React navigation
                    // via PublicRoute and ProtectedRoute components.
                }
                dispatch(getCurrentUserDetailsActionSuccess(userData));
                return userData;
            }

        } catch (error) {
            isFetchingUserDetails = false;
            const errorMessage = error.response?.data?.error || error.response?.data?.message || "Failed to get current user details";
            console.error("getCurrentUserDetailsActionError", error.response?.data);
            dispatch(getCurrentUserDetailsActionError(errorMessage));
            throw error;
        }
    };
};
